import { notify } from 'utils/reduxUtils';

export const types = {
  DISCOVER: 'auth/login/DISCOVER',
  DISCOVER_SUCCESS: 'auth/login/DISCOVER_SUCCESS',
  DISCOVER_RESET: 'auth/login/DISCOVER_RESET',
  LOGIN: 'auth/login/LOGIN',
  LOGIN_SUCCESS: 'auth/login/LOGIN_SUCCESS',
  LOGIN_ERROR: 'auth/login/LOGIN_ERROR',
  LOGOUT_REQUEST: 'auth/login/LOGOUT_REQUEST',
  LOGOUT_SUCCESS: 'auth/login/LOGOUT_SUCCESS',
  ACCEPT_TERMS_ERROR: 'auth/login/ACCEPT_TERMS_ERROR',
  ACCEPT_TERMS_REQUEST: 'auth/login/ACCEPT_TERMS_REQUEST',
  ACCEPT_TERMS_SUCCESS: 'auth/login/ACCEPT_TERMS_SUCCESS',
};

export const discover = {
  /**
   * @param {string} email
   * @param {string} [next] - next query param, forwarded so the OIDC callback
   *   can send the browser back to where the user was headed
   */
  request: (email, next) => ({
    type: types.DISCOVER,
    payload: { email, next },
  }),
  /**
   * @param {string} step - a value from AUTH_STEPS
   */
  success: (step) => ({
    type: types.DISCOVER_SUCCESS,
    payload: { step },
  }),
  /** Return to the email step, e.g. the user mistyped their address. */
  reset: () => ({
    type: types.DISCOVER_RESET,
  }),
};

export const login = {
  error: (error) => ({
    type: types.LOGIN_ERROR,
    payload: error,
  }),
  /**
   * @param {string} credentials.username
   * @param {string} credentials.password
   * @param {bool}   credentials.extendLoginTimeout
   * @param {string} next
   */
  request: (credentials, next) => ({
    type: types.LOGIN,
    payload: { credentials, next },
  }),
  success: (accessToken, user) => ({
    type: types.LOGIN_SUCCESS,
    payload: { accessToken, user },
  }),
};

export const logout = () => ({
  type: types.LOGOUT_REQUEST,
});

export const logoutSuccess = () => ({
  type: types.LOGOUT_SUCCESS,
});

export const acceptTerms = {
  request: ({ acceptedTerms }) => ({
    type: types.ACCEPT_TERMS_REQUEST,
    payload: { acceptedTerms },
  }),
  success: () => ({
    type: types.ACCEPT_TERMS_SUCCESS,
  }),
  error: notify(
    ({ error }) => ({
      type: types.ACCEPT_TERMS_ERROR,
      payload: error,
    }),
    'Something went wrong when accepting the standard terms.',
  ),
};
